import 'swiper/css';

import { useRequest } from 'ahooks';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';

import * as doleApi from '@/api/dole/index';
import { implog } from '@/api/implog';
import goldCoins from '@/assets/modal/gold_coins.webp';
import Button from '@/components/button';
import BlurryLoadingImage from '@/components/progressive-img';
import { DOLE_NUM, DOLE_RECEIVE_NUM } from '@/constant/config';
import globalStore from '@/stores/store';
import { toast } from '@/utils/toast';

import styles from './styles.module.less';

const DoleModal = () => {
  const swiperRef = useRef<any>();

  const { data: doleData = {}, run: updateDoleData } = useRequest(doleApi.getDoleDetail, {
    manual: true
  });

  const { loading: isDoleReceiving, run: receiveDoleApi } = useRequest(doleApi.receiveDole, {
    manual: true,
    onSuccess: async () => {
      await globalStore.fetchBalance();
      await updateDoleData();
    }
  });

  const currentDoleDetail = doleData?.res?.[0] || {};
  const receiveLeftNum = DOLE_RECEIVE_NUM - (doleData.has_taken_today ?? 0);

  const isCanReceive = receiveLeftNum > 0 && globalStore.initialState.score < DOLE_NUM;

  useEffect(() => {
    implog('dole_modal_show');
    updateDoleData();
    swiperRef.current?.swiper?.slideTo?.(0);
  }, []);

  const getDole = () => {
    if (isDoleReceiving) return;
    if (!isCanReceive) {
      toast('Currently, you do not meet the conditions to receive it.', { id: 'cannot-receive-dole' });
      return;
    }
    implog('get_dole');
    receiveDoleApi();
  };

  return (
    <div className={styles.container}>
      {/* 上半部分 */}
      <div className={styles.dole}>
        <div className={styles['dole__title']}>Rescue Bonus</div>
        <div className={styles['dole__desc']}>
          <p>
            If your balance is below<span className={styles['dole__desc-tip']}> ${DOLE_NUM}</span>,you can claim
          </p>
          <p>rescue funds up to 3 times per day.</p>
        </div>

        <div className={styles['dole__content']}>
          <BlurryLoadingImage loading="lazy" className={styles['dole__cover']} src={goldCoins} alt="" />
          <div className={styles['dole__amount']}>$ {currentDoleDetail.alms_amount}</div>
        </div>

        <Button
          className={classNames(styles['dole__action'], { [styles.disabled]: !isCanReceive })}
          onClick={() => getDole()}
        >
          Claim Bonus {'('}
          {receiveLeftNum < 0 ? 0 : receiveLeftNum}/{DOLE_RECEIVE_NUM} Today{')'}
        </Button>
      </div>
      <div className={styles.tips}>Deposit any amount and get an extra $1-2 bonus the next day</div>
    </div>
  );
};

export default DoleModal;
